import React from 'react';

const Skeleton = ({ className }) => (
    <div className={`animate-pulse bg-gray-800 rounded-xl ${className}`}></div>
);

export const HomeSkeleton = () => {
    return (
        <div className="space-y-8 p-4">
            {/* Slider Skeleton */}
            <Skeleton className="aspect-[16/9] w-full rounded-[2.5rem]" />

            {/* Banner Skeleton */}
            <Skeleton className="h-24 w-full rounded-[2rem]" />

            {/* Sub Status Skeleton */}
            <Skeleton className="h-48 w-full rounded-[2.5rem]" />

            {/* Grid Skeleton */}
            <div className="grid grid-cols-2 gap-4">
                <Skeleton className="h-32 rounded-[2.5rem]" />
                <Skeleton className="h-32 rounded-[2.5rem]" />
                <Skeleton className="h-32 rounded-[2.5rem]" />
                <Skeleton className="h-32 rounded-[2.5rem]" />
            </div>

            {/* List Skeleton */}
            <div className="space-y-4">
                <Skeleton className="h-6 w-32" />
                <Skeleton className="h-24 w-full" />
                <Skeleton className="h-24 w-full" />
            </div>
        </div>
    );
};

export default Skeleton;
